/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedCertificatesRouteImport } from './routes/_authenticated/certificates'
import { Route as AuthenticatedCharterRouteImport } from './routes/_authenticated/charter'
import { Route as AuthenticatedCrewRouteImport } from './routes/_authenticated/crew'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedExpeditionsRouteImport } from './routes/_authenticated/expeditions'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedReportsRouteImport } from './routes/_authenticated/reports'
import { Route as AuthenticatedRoutesRouteImport } from './routes/_authenticated/routes'
import { Route as AuthenticatedSchoolRouteImport } from './routes/_authenticated/school'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedSkillsRouteImport } from './routes/_authenticated/skills'
import { Route as AuthenticatedVesselsRouteImport } from './routes/_authenticated/vessels'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AuthLogoutRouteImport } from './routes/auth/logout'
import { Route as AuthenticatedCrewIndexRouteImport } from './routes/_authenticated/crew.index'
import { Route as AuthenticatedCrewMemberIdRouteImport } from './routes/_authenticated/crew.$memberId'
import { Route as AuthenticatedExpeditionsIndexRouteImport } from './routes/_authenticated/expeditions.index'
import { Route as AuthenticatedExpeditionsExpeditionSlugRouteImport } from './routes/_authenticated/expeditions.$expeditionSlug'
import { Route as AuthenticatedExpeditionsNewRouteImport } from './routes/_authenticated/expeditions.new'
import { Route as AuthenticatedRoutesIndexRouteImport } from './routes/_authenticated/routes.index'
import { Route as AuthenticatedRoutesRouteIdRouteImport } from './routes/_authenticated/routes.$routeId'
import { Route as AuthenticatedVesselsIndexRouteImport } from './routes/_authenticated/vessels.index'
import { Route as AuthenticatedVesselsVesselSlugRouteImport } from './routes/_authenticated/vessels.$vesselSlug'
import { Route as AuthenticatedVesselsNewRouteImport } from './routes/_authenticated/vessels.new'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedCertificatesRoute =
  AuthenticatedCertificatesRouteImport.update({
    id: '/certificates',
    path: '/certificates',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCharterRoute = AuthenticatedCharterRouteImport.update({
  id: '/charter',
  path: '/charter',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCrewRoute = AuthenticatedCrewRouteImport.update({
  id: '/crew',
  path: '/crew',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedExpeditionsRoute =
  AuthenticatedExpeditionsRouteImport.update({
    id: '/expeditions',
    path: '/expeditions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNotificationsRoute =
  AuthenticatedNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReportsRoute = AuthenticatedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRoutesRoute = AuthenticatedRoutesRouteImport.update({
  id: '/routes',
  path: '/routes',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSchoolRoute = AuthenticatedSchoolRouteImport.update({
  id: '/school',
  path: '/school',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSkillsRoute = AuthenticatedSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedVesselsRoute = AuthenticatedVesselsRouteImport.update({
  id: '/vessels',
  path: '/vessels',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLogoutRoute = AuthLogoutRouteImport.update({
  id: '/auth/logout',
  path: '/auth/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedCrewIndexRoute = AuthenticatedCrewIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedCrewRoute,
} as any)
const AuthenticatedCrewMemberIdRoute =
  AuthenticatedCrewMemberIdRouteImport.update({
    id: '/$memberId',
    path: '/$memberId',
    getParentRoute: () => AuthenticatedCrewRoute,
  } as any)
const AuthenticatedExpeditionsIndexRoute =
  AuthenticatedExpeditionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedExpeditionsRoute,
  } as any)
const AuthenticatedExpeditionsExpeditionSlugRoute =
  AuthenticatedExpeditionsExpeditionSlugRouteImport.update({
    id: '/$expeditionSlug',
    path: '/$expeditionSlug',
    getParentRoute: () => AuthenticatedExpeditionsRoute,
  } as any)
const AuthenticatedExpeditionsNewRoute =
  AuthenticatedExpeditionsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedExpeditionsRoute,
  } as any)
const AuthenticatedRoutesIndexRoute =
  AuthenticatedRoutesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedRoutesRoute,
  } as any)
const AuthenticatedRoutesRouteIdRoute =
  AuthenticatedRoutesRouteIdRouteImport.update({
    id: '/$routeId',
    path: '/$routeId',
    getParentRoute: () => AuthenticatedRoutesRoute,
  } as any)
const AuthenticatedVesselsIndexRoute =
  AuthenticatedVesselsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedVesselsRoute,
  } as any)
const AuthenticatedVesselsVesselSlugRoute =
  AuthenticatedVesselsVesselSlugRouteImport.update({
    id: '/$vesselSlug',
    path: '/$vesselSlug',
    getParentRoute: () => AuthenticatedVesselsRoute,
  } as any)
const AuthenticatedVesselsNewRoute = AuthenticatedVesselsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedVesselsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/certificates': typeof AuthenticatedCertificatesRoute
  '/charter': typeof AuthenticatedCharterRoute
  '/crew': typeof AuthenticatedCrewRouteWithChildren
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/expeditions': typeof AuthenticatedExpeditionsRouteWithChildren
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/reports': typeof AuthenticatedReportsRoute
  '/routes': typeof AuthenticatedRoutesRouteWithChildren
  '/school': typeof AuthenticatedSchoolRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/skills': typeof AuthenticatedSkillsRoute
  '/vessels': typeof AuthenticatedVesselsRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/crew/$memberId': typeof AuthenticatedCrewMemberIdRoute
  '/expeditions/$expeditionSlug': typeof AuthenticatedExpeditionsExpeditionSlugRoute
  '/expeditions/new': typeof AuthenticatedExpeditionsNewRoute
  '/routes/$routeId': typeof AuthenticatedRoutesRouteIdRoute
  '/vessels/$vesselSlug': typeof AuthenticatedVesselsVesselSlugRoute
  '/vessels/new': typeof AuthenticatedVesselsNewRoute
  '/crew/': typeof AuthenticatedCrewIndexRoute
  '/expeditions/': typeof AuthenticatedExpeditionsIndexRoute
  '/routes/': typeof AuthenticatedRoutesIndexRoute
  '/vessels/': typeof AuthenticatedVesselsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/certificates': typeof AuthenticatedCertificatesRoute
  '/charter': typeof AuthenticatedCharterRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/reports': typeof AuthenticatedReportsRoute
  '/school': typeof AuthenticatedSchoolRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/skills': typeof AuthenticatedSkillsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/crew/$memberId': typeof AuthenticatedCrewMemberIdRoute
  '/expeditions/$expeditionSlug': typeof AuthenticatedExpeditionsExpeditionSlugRoute
  '/expeditions/new': typeof AuthenticatedExpeditionsNewRoute
  '/routes/$routeId': typeof AuthenticatedRoutesRouteIdRoute
  '/vessels/$vesselSlug': typeof AuthenticatedVesselsVesselSlugRoute
  '/vessels/new': typeof AuthenticatedVesselsNewRoute
  '/crew': typeof AuthenticatedCrewIndexRoute
  '/expeditions': typeof AuthenticatedExpeditionsIndexRoute
  '/routes': typeof AuthenticatedRoutesIndexRoute
  '/vessels': typeof AuthenticatedVesselsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/certificates': typeof AuthenticatedCertificatesRoute
  '/_authenticated/charter': typeof AuthenticatedCharterRoute
  '/_authenticated/crew': typeof AuthenticatedCrewRouteWithChildren
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/expeditions': typeof AuthenticatedExpeditionsRouteWithChildren
  '/_authenticated/notifications': typeof AuthenticatedNotificationsRoute
  '/_authenticated/reports': typeof AuthenticatedReportsRoute
  '/_authenticated/routes': typeof AuthenticatedRoutesRouteWithChildren
  '/_authenticated/school': typeof AuthenticatedSchoolRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/skills': typeof AuthenticatedSkillsRoute
  '/_authenticated/vessels': typeof AuthenticatedVesselsRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/_authenticated/crew/$memberId': typeof AuthenticatedCrewMemberIdRoute
  '/_authenticated/expeditions/$expeditionSlug': typeof AuthenticatedExpeditionsExpeditionSlugRoute
  '/_authenticated/expeditions/new': typeof AuthenticatedExpeditionsNewRoute
  '/_authenticated/routes/$routeId': typeof AuthenticatedRoutesRouteIdRoute
  '/_authenticated/vessels/$vesselSlug': typeof AuthenticatedVesselsVesselSlugRoute
  '/_authenticated/vessels/new': typeof AuthenticatedVesselsNewRoute
  '/_authenticated/crew/': typeof AuthenticatedCrewIndexRoute
  '/_authenticated/expeditions/': typeof AuthenticatedExpeditionsIndexRoute
  '/_authenticated/routes/': typeof AuthenticatedRoutesIndexRoute
  '/_authenticated/vessels/': typeof AuthenticatedVesselsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/certificates'
    | '/charter'
    | '/crew'
    | '/dashboard'
    | '/expeditions'
    | '/notifications'
    | '/reports'
    | '/routes'
    | '/school'
    | '/settings'
    | '/skills'
    | '/vessels'
    | '/auth/callback'
    | '/auth/logout'
    | '/crew/$memberId'
    | '/expeditions/$expeditionSlug'
    | '/expeditions/new'
    | '/routes/$routeId'
    | '/vessels/$vesselSlug'
    | '/vessels/new'
    | '/crew/'
    | '/expeditions/'
    | '/routes/'
    | '/vessels/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/certificates'
    | '/charter'
    | '/dashboard'
    | '/notifications'
    | '/reports'
    | '/school'
    | '/settings'
    | '/skills'
    | '/auth/callback'
    | '/auth/logout'
    | '/crew/$memberId'
    | '/expeditions/$expeditionSlug'
    | '/expeditions/new'
    | '/routes/$routeId'
    | '/vessels/$vesselSlug'
    | '/vessels/new'
    | '/crew'
    | '/expeditions'
    | '/routes'
    | '/vessels'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_authenticated/certificates'
    | '/_authenticated/charter'
    | '/_authenticated/crew'
    | '/_authenticated/dashboard'
    | '/_authenticated/expeditions'
    | '/_authenticated/notifications'
    | '/_authenticated/reports'
    | '/_authenticated/routes'
    | '/_authenticated/school'
    | '/_authenticated/settings'
    | '/_authenticated/skills'
    | '/_authenticated/vessels'
    | '/auth/callback'
    | '/auth/logout'
    | '/_authenticated/crew/$memberId'
    | '/_authenticated/expeditions/$expeditionSlug'
    | '/_authenticated/expeditions/new'
    | '/_authenticated/routes/$routeId'
    | '/_authenticated/vessels/$vesselSlug'
    | '/_authenticated/vessels/new'
    | '/_authenticated/crew/'
    | '/_authenticated/expeditions/'
    | '/_authenticated/routes/'
    | '/_authenticated/vessels/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthLogoutRoute: typeof AuthLogoutRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/certificates': {
      id: '/_authenticated/certificates'
      path: '/certificates'
      fullPath: '/certificates'
      preLoaderRoute: typeof AuthenticatedCertificatesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/charter': {
      id: '/_authenticated/charter'
      path: '/charter'
      fullPath: '/charter'
      preLoaderRoute: typeof AuthenticatedCharterRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/crew': {
      id: '/_authenticated/crew'
      path: '/crew'
      fullPath: '/crew'
      preLoaderRoute: typeof AuthenticatedCrewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/expeditions': {
      id: '/_authenticated/expeditions'
      path: '/expeditions'
      fullPath: '/expeditions'
      preLoaderRoute: typeof AuthenticatedExpeditionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notifications': {
      id: '/_authenticated/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports': {
      id: '/_authenticated/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthenticatedReportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/routes': {
      id: '/_authenticated/routes'
      path: '/routes'
      fullPath: '/routes'
      preLoaderRoute: typeof AuthenticatedRoutesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/school': {
      id: '/_authenticated/school'
      path: '/school'
      fullPath: '/school'
      preLoaderRoute: typeof AuthenticatedSchoolRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/skills': {
      id: '/_authenticated/skills'
      path: '/skills'
      fullPath: '/skills'
      preLoaderRoute: typeof AuthenticatedSkillsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vessels': {
      id: '/_authenticated/vessels'
      path: '/vessels'
      fullPath: '/vessels'
      preLoaderRoute: typeof AuthenticatedVesselsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/logout': {
      id: '/auth/logout'
      path: '/auth/logout'
      fullPath: '/auth/logout'
      preLoaderRoute: typeof AuthLogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/crew/': {
      id: '/_authenticated/crew/'
      path: '/'
      fullPath: '/crew/'
      preLoaderRoute: typeof AuthenticatedCrewIndexRouteImport
      parentRoute: typeof AuthenticatedCrewRoute
    }
    '/_authenticated/crew/$memberId': {
      id: '/_authenticated/crew/$memberId'
      path: '/$memberId'
      fullPath: '/crew/$memberId'
      preLoaderRoute: typeof AuthenticatedCrewMemberIdRouteImport
      parentRoute: typeof AuthenticatedCrewRoute
    }
    '/_authenticated/expeditions/': {
      id: '/_authenticated/expeditions/'
      path: '/'
      fullPath: '/expeditions/'
      preLoaderRoute: typeof AuthenticatedExpeditionsIndexRouteImport
      parentRoute: typeof AuthenticatedExpeditionsRoute
    }
    '/_authenticated/expeditions/$expeditionSlug': {
      id: '/_authenticated/expeditions/$expeditionSlug'
      path: '/$expeditionSlug'
      fullPath: '/expeditions/$expeditionSlug'
      preLoaderRoute: typeof AuthenticatedExpeditionsExpeditionSlugRouteImport
      parentRoute: typeof AuthenticatedExpeditionsRoute
    }
    '/_authenticated/expeditions/new': {
      id: '/_authenticated/expeditions/new'
      path: '/new'
      fullPath: '/expeditions/new'
      preLoaderRoute: typeof AuthenticatedExpeditionsNewRouteImport
      parentRoute: typeof AuthenticatedExpeditionsRoute
    }
    '/_authenticated/routes/': {
      id: '/_authenticated/routes/'
      path: '/'
      fullPath: '/routes/'
      preLoaderRoute: typeof AuthenticatedRoutesIndexRouteImport
      parentRoute: typeof AuthenticatedRoutesRoute
    }
    '/_authenticated/routes/$routeId': {
      id: '/_authenticated/routes/$routeId'
      path: '/$routeId'
      fullPath: '/routes/$routeId'
      preLoaderRoute: typeof AuthenticatedRoutesRouteIdRouteImport
      parentRoute: typeof AuthenticatedRoutesRoute
    }
    '/_authenticated/vessels/': {
      id: '/_authenticated/vessels/'
      path: '/'
      fullPath: '/vessels/'
      preLoaderRoute: typeof AuthenticatedVesselsIndexRouteImport
      parentRoute: typeof AuthenticatedVesselsRoute
    }
    '/_authenticated/vessels/$vesselSlug': {
      id: '/_authenticated/vessels/$vesselSlug'
      path: '/$vesselSlug'
      fullPath: '/vessels/$vesselSlug'
      preLoaderRoute: typeof AuthenticatedVesselsVesselSlugRouteImport
      parentRoute: typeof AuthenticatedVesselsRoute
    }
    '/_authenticated/vessels/new': {
      id: '/_authenticated/vessels/new'
      path: '/new'
      fullPath: '/vessels/new'
      preLoaderRoute: typeof AuthenticatedVesselsNewRouteImport
      parentRoute: typeof AuthenticatedVesselsRoute
    }
  }
}

interface AuthenticatedCrewRouteChildren {
  AuthenticatedCrewMemberIdRoute: typeof AuthenticatedCrewMemberIdRoute
  AuthenticatedCrewIndexRoute: typeof AuthenticatedCrewIndexRoute
}

const AuthenticatedCrewRouteChildren: AuthenticatedCrewRouteChildren = {
  AuthenticatedCrewMemberIdRoute: AuthenticatedCrewMemberIdRoute,
  AuthenticatedCrewIndexRoute: AuthenticatedCrewIndexRoute,
}

const AuthenticatedCrewRouteWithChildren =
  AuthenticatedCrewRoute._addFileChildren(AuthenticatedCrewRouteChildren)

interface AuthenticatedExpeditionsRouteChildren {
  AuthenticatedExpeditionsExpeditionSlugRoute: typeof AuthenticatedExpeditionsExpeditionSlugRoute
  AuthenticatedExpeditionsNewRoute: typeof AuthenticatedExpeditionsNewRoute
  AuthenticatedExpeditionsIndexRoute: typeof AuthenticatedExpeditionsIndexRoute
}

const AuthenticatedExpeditionsRouteChildren: AuthenticatedExpeditionsRouteChildren =
  {
    AuthenticatedExpeditionsExpeditionSlugRoute:
      AuthenticatedExpeditionsExpeditionSlugRoute,
    AuthenticatedExpeditionsNewRoute: AuthenticatedExpeditionsNewRoute,
    AuthenticatedExpeditionsIndexRoute: AuthenticatedExpeditionsIndexRoute,
  }

const AuthenticatedExpeditionsRouteWithChildren =
  AuthenticatedExpeditionsRoute._addFileChildren(
    AuthenticatedExpeditionsRouteChildren,
  )

interface AuthenticatedRoutesRouteChildren {
  AuthenticatedRoutesRouteIdRoute: typeof AuthenticatedRoutesRouteIdRoute
  AuthenticatedRoutesIndexRoute: typeof AuthenticatedRoutesIndexRoute
}

const AuthenticatedRoutesRouteChildren: AuthenticatedRoutesRouteChildren = {
  AuthenticatedRoutesRouteIdRoute: AuthenticatedRoutesRouteIdRoute,
  AuthenticatedRoutesIndexRoute: AuthenticatedRoutesIndexRoute,
}

const AuthenticatedRoutesRouteWithChildren =
  AuthenticatedRoutesRoute._addFileChildren(AuthenticatedRoutesRouteChildren)

interface AuthenticatedVesselsRouteChildren {
  AuthenticatedVesselsVesselSlugRoute: typeof AuthenticatedVesselsVesselSlugRoute
  AuthenticatedVesselsNewRoute: typeof AuthenticatedVesselsNewRoute
  AuthenticatedVesselsIndexRoute: typeof AuthenticatedVesselsIndexRoute
}

const AuthenticatedVesselsRouteChildren: AuthenticatedVesselsRouteChildren = {
  AuthenticatedVesselsVesselSlugRoute: AuthenticatedVesselsVesselSlugRoute,
  AuthenticatedVesselsNewRoute: AuthenticatedVesselsNewRoute,
  AuthenticatedVesselsIndexRoute: AuthenticatedVesselsIndexRoute,
}

const AuthenticatedVesselsRouteWithChildren =
  AuthenticatedVesselsRoute._addFileChildren(AuthenticatedVesselsRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedCertificatesRoute: typeof AuthenticatedCertificatesRoute
  AuthenticatedCharterRoute: typeof AuthenticatedCharterRoute
  AuthenticatedCrewRoute: typeof AuthenticatedCrewRouteWithChildren
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedExpeditionsRoute: typeof AuthenticatedExpeditionsRouteWithChildren
  AuthenticatedNotificationsRoute: typeof AuthenticatedNotificationsRoute
  AuthenticatedReportsRoute: typeof AuthenticatedReportsRoute
  AuthenticatedRoutesRoute: typeof AuthenticatedRoutesRouteWithChildren
  AuthenticatedSchoolRoute: typeof AuthenticatedSchoolRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedSkillsRoute: typeof AuthenticatedSkillsRoute
  AuthenticatedVesselsRoute: typeof AuthenticatedVesselsRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedCertificatesRoute: AuthenticatedCertificatesRoute,
  AuthenticatedCharterRoute: AuthenticatedCharterRoute,
  AuthenticatedCrewRoute: AuthenticatedCrewRouteWithChildren,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedExpeditionsRoute: AuthenticatedExpeditionsRouteWithChildren,
  AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,
  AuthenticatedReportsRoute: AuthenticatedReportsRoute,
  AuthenticatedRoutesRoute: AuthenticatedRoutesRouteWithChildren,
  AuthenticatedSchoolRoute: AuthenticatedSchoolRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedSkillsRoute: AuthenticatedSkillsRoute,
  AuthenticatedVesselsRoute: AuthenticatedVesselsRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthLogoutRoute: AuthLogoutRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
